export default __webpack_public_path__ + "static/media/onboarding_void_check_.c6ad1b8b.png";